import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../../../services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailConfig } from '../../../../dto/email-config';

@Component({
  selector: 'app-email-config',
  templateUrl: './email-config.component.html',
  styleUrls: ['./email-config.component.css']
})
export class EmailConfigComponent implements OnInit {

  constructor(
    private configService: ConfigService,
    private formBuilder: FormBuilder,
  ) { }

  configForm: FormGroup;

  ngOnInit() {
    this.configService.getEmailConfig().subscribe(data => {
      this.initForm(data);
    });
  }

  initForm(value: EmailConfig = null) {
    if (value != null) {
      this.configForm = this.formBuilder.group({
        fromEmail: [value.fromEmail, Validators.required],
        fromName: [value.fromName, Validators.required],
        reminderDistributionEnabled: [value.reminderDistributionEnabled, Validators.required],
        reportDistributionEnabled: [value.reportDistributionEnabled, Validators.required],
        maxRemindersPerDistribution: [value.maxRemindersPerDistribution, Validators.compose([Validators.required, Validators.min(10)])],
      });
    }
    this.configForm.markAsPristine();
  }

  onSubmit(form: FormGroup) {
    this.configService.setEmailConfig(form.value).subscribe(result => {
      this.initForm();
    });
  }
}
